// =====================================================
// 📁 QuotationSummaryTotalRow.tsx
// =====================================================

import { formatCurrency } from '../../../../../../utils/formatCurrency';

interface Props {
  item: any;
}

const QuotationSummaryTotalRow: React.FC<Props> = ({ item }) => {
  // =====================================================
  // 🔹 Values
  // =====================================================

  const value = Number(item.value || 0);

  const isDiscount =
    item.key === 'itemsDiscountTotal' || item.key === 'globalDiscountAmount';

  // =====================================================
  // 🎨 Render
  // =====================================================

  return (
    <div
      className="
        flex
        items-center
        justify-between

        gap-3
      "
    >
      {/* ===================================================== */}
      {/* 🔹 Label */}
      {/* ===================================================== */}

      <span
        className="
          text-sm

          text-body

          dark:text-bodydark1
        "
      >
        {item.label}
      </span>

      {/* ===================================================== */}
      {/* 🔹 Value */}
      {/* ===================================================== */}

      <span
        className={`
          text-sm
          font-semibold

          ${
            isDiscount
              ? `
                  text-danger
                `
              : `
                  text-black

                  dark:text-white
                `
          }
        `}
      >
        {isDiscount ? '-' : ''}${formatCurrency(value)}
      </span>
    </div>
  );
};

export default QuotationSummaryTotalRow;
